module.exports = __webpack_public_path__ + "media/images/clearbanc-card-ico-7dc356155cc3337f5a2015f3ec7fa66e.svg";